export const modalConfigs = {
  aqi_eu: {
    title: 'AQI',
    min: 1,
    max: 6,
    values: [1, 2, 3, 4, 5, '6+'],
    colorMeaning: [
      'Good',
      'Fair',
      'Moderate',
      'Poor',
      'Very_Poor',
      'Extremely '
    ],
    colors: ['#559f58', '#a7d35c', '#ecd448', '#f5be41', '#f09235', '#da3322'],
    info: 'The Air Quality Index (AQI) is used for reporting daily air quality. It tells you how clean or polluted your air is, and what associated health effects might be a concern for you. The AQI focuses on health effects you may experience within a few hours or days after breathing polluted air. EPA calculates the AQI for five major air pollutants regulated by the Clean Air Act: ground-level ozone, particle pollution (also known as particulate matter), carbon monoxide, sulfur dioxide, and nitrogen dioxide. For each of these pollutants, EPA has established national air quality standards to protect public health. Ground-level ozone and airborne particles are the two pollutants that pose the greatest threat to human health in this country.'
  },
  pm25: {
    title: 'PM2.5',
    min: 0,
    max: 75,
    values: [0, 10, 20, 25, 50, 75, '75+'],
    colorMeaning: [
      'Good',
      'Fair',
      'Moderate',
      'Poor',
      'Very_Poor ',
      'Extremly '
    ],
    colors: ['#559f58', '#a7d35c', '#ecd448', '#f5be41', '#f09235', '#da3322'],
    info: 'Particulate Matter 2.5 (PM2.5) refers to particles with a diameter 2.5 μm or less. PM2.5 can get down into the deepest (alveolar) portions of the lungs where gas exchange occurs between the air and your bloodstream.Exposure to high concentrations of PM2.5 can cause diseases in respiratory and cardiovascular systems.'
  },
  pm10: {
    title: 'PM10',
    min: 0,
    max: 150,
    values: [0, 20, 40, 50, 100, 150, '150+'],
    colorMeaning: [
      'Good',
      'Fair',
      'Moderate',
      'Poor',
      'Very_Poor ',
      'Extremely '
    ],
    colors: ['#559f58', '#a7d35c', '#ecd448', '#f5be41', '#f09235', '#da3322'],
    info: 'Particulate Matter 10 (PM10) refers to particles with a diameter 10 μm or less. PM10 can get down into the deepest (alveolar) portions of the lungs where gas exchange occurs between the air and your bloodstream. Exposure to high concentrations of PM10 can cause diseases in respiratory and cardiovascular systems'
  },
  no2: {
    title: 'NO2',
    min: 0,
    max: 340,
    values: [0, 40, 90, 120, 230, 340, '340+'],
    colorMeaning: [
      'Good',
      'Fair',
      'Moderate',
      'Poor',
      'Very_Poor ',
      'Extremely '
    ],
    colors: ['#559f58', '#a7d35c', '#ecd448', '#f5be41', '#f09235', '#da3322'],
    info: 'NO2 is one of a group of highly reactive gases known as oxides of nitrogen or nitrogen oxides (NOx). Other nitrogen oxides include nitrous acid and nitric acid. NO2 is used as the indicator for the larger group of nitrogen oxides. NO2 primarily gets in the air from the burning of fuel. NO2 forms from emissions from cars, trucks and buses, power plants, and off-road equipment. Exposure to high concentrations of NO2 can cause diseases in respiratory and cardiovascular systems.'
  },
  o3: {
    title: 'O3',
    min: 0,
    max: 380,
    values: [0, 50, 100, 130, 240, 380, '380+'],
    colorMeaning: [
      'Good',
      'Fair',
      'Moderate',
      'Poor',
      'Very_Poor ',
      'Extremely'
    ],
    colors: ['#559f58', '#a7d35c', '#ecd448', '#f5be41', '#f09235', '#da3322'],
    info: "O3 is a gas composed of three oxygen atoms. It is not usually emitted directly into the air, but at ground-level is created by a chemical reaction between oxides of nitrogen (NOx) and volatile organic compounds (VOC) in the presence of sunlight. Ozone has the same chemical structure whether it occurs miles above the earth or at ground-level and can be either 'good' or 'bad,' depending on its location in the atmosphere. Exposure to high concentrations of O3 can cause diseases in respiratory and cardiovascular systems."
  }
}
